import React, { useContext } from 'react';
import html2canvas from 'html2canvas';
import { renderToStaticMarkup } from 'react-dom/server';
import { QESButton } from '@app/shared/qes-standards/Button';
import { formatDateTime } from '@app/shared/formatDateTime';
import { CountyProjectContext } from '@app/projects/CountyProjectContext';

interface MapExportProps {
  isLoading: boolean;
}

const MapExport: React.FC<MapExportProps> = ({ isLoading }) => {

  const projectContext = useContext(CountyProjectContext);

  const exportMap = () => {
    const titleDiv = getTitleDiv();
    const exportNameOriginal = `Gap Density Map ${projectContext.project.resource.name}`;
    const exportName =  exportNameOriginal.replace(/\./g, "_");
    const selector = '.gap-density-map__map-container';
    const exportDiv = document.querySelector(selector) as HTMLElement;

    html2canvas(exportDiv as HTMLElement, {
      ignoreElements: function (element) {
        return element.classList.contains("mapboxgl-ctrl-group");
      },
      onclone: (clonedDoc) => {
        const clonedExportDiv = clonedDoc.querySelector(selector) as HTMLElement;

        if (clonedExportDiv) {
          clonedExportDiv.className = 'gap-density-map__map-export-canvas-container';
          clonedExportDiv.insertBefore(titleDiv, clonedExportDiv.firstChild);
        }
      },
      removeContainer: true,
      scale: 2

    }).then(exportCanvas => {
      const imgData = exportCanvas.toDataURL("image/png");

      const link = document.createElement('a');
      link.download = exportName;
      link.href = imgData;
      link.click();
    });
  };

  const getTimesliceDate = () => {
    if (projectContext.runConfiguration.isProjected) {
      return "Timeslice: Projected";
    } else if (projectContext.runConfiguration.isTermed) {
      return "Timeslice: Terminated";
    } else if (projectContext.runConfiguration.isProjectedTermed) {
      return "Timeslice: Proj-Termed";
    } else {
      return `Timeslice Date: ${formatDateTime(projectContext.runConfiguration.dateCreated)}`;
    }
  }

  const getTitleDiv = () => {
    const output = document.createElement('a');
    output.innerHTML =
      renderToStaticMarkup(
        <div className='title-div'>
          <img className="title-image" src={`${window.customUIBaseUrl}/images/QuestAnalyticsLogo-R.png`} alt="Quest Analytics" role="img" id="logo" />
          <div className="text-container">
            <span className="title-text">{projectContext.project.resource.name} Gap Density Map</span>
            <span className="date-text">Map Created on: {new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            <span className="date-text">{getTimesliceDate()}</span>
          </div>
        </div>
      );

    return output;
  }

  return (
    <>
      { !isLoading &&
        <div className="pull-right" data-html2canvas-ignore="true">
          <QESButton
            className="gap-density-map__export-button"
            qesTestId="gap-density-map__export-button"
            qesType="primary"
            onClick={() => exportMap()}>
              Export
          </QESButton>
        </div>
      }
    </>
  );
};

export default MapExport;
